import { render } from "./BanobagiTransactionList.vue?vue&type=template&id=5fc6fc88&scoped=true"
import script from "./BanobagiTransactionList.vue?vue&type=script&lang=js"
export * from "./BanobagiTransactionList.vue?vue&type=script&lang=js"

import "./BanobagiTransactionList.vue?vue&type=style&index=0&id=5fc6fc88&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc6fc88"]])

export default __exports__